import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classnames from 'classnames2';
import React from 'react';
import * as styles from './Label.scss';
export var Label = function Label(_ref) {
  var _classes;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'label' : _ref$as,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      dataTest = _ref.dataTest,
      disabled = _ref.disabled,
      htmlFor = _ref.htmlFor,
      id = _ref.id,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["as", "children", "className", "color", "dataTest", "disabled", "htmlFor", "id", "variant"]);

  var classes = (_classes = {}, _defineProperty(_classes, styles.label, variant !== 'group'), _defineProperty(_classes, styles.groupLabel, variant === 'group'), _defineProperty(_classes, styles.colorDark, color === 'dark'), _defineProperty(_classes, styles.disabled, disabled), _classes);
  var HtmlElement = as;
  return React.createElement(HtmlElement, Object.assign({
    className: classnames(classes, className),
    "data-test": dataTest,
    id: id
  }, HtmlElement === 'legend' || HtmlElement === 'span' ? null : {
    htmlFor: htmlFor
  }, rest), children);
};